import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { CoreModule } from './core.module';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigService } from './services/config.service';



@NgModule({
  declarations: [AppComponent],
  imports: [
   CoreModule,
   BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => configService.loadConfig().toPromise(),
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
